module.exports = __webpack_public_path__ + "img/zhifubao.991cdb5c.png";